const UploadAttachmentSvg = () => {
	return (
		<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.83203 16.0005C5.83203 18.8295 6.95584 21.5426 8.95623 23.543C10.9566 25.5433 13.6697 26.6672 16.4987 26.6672C19.3277 26.6672 22.0408 25.5433 24.0412 23.543C26.0416 21.5426 27.1654 18.8295 27.1654 16.0005"
				stroke="#22031F"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M16.5 5.33398V18.6673M16.5 18.6673L20.5 14.6673M16.5 18.6673L12.5 14.6673"
				stroke="#22031F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default UploadAttachmentSvg;
